import { render, staticRenderFns } from "./Heredity.vue?vue&type=template&id=27b2f353&scoped=true"
import script from "./Heredity.vue?vue&type=script&lang=js"
export * from "./Heredity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2f353",
  null
  
)

export default component.exports